import VerifikasiSkl from "./partial/VerifikasiSkl";

export default function VerifikasiSklDetailPage() {
  return (
    <div>
      <VerifikasiSkl />
    </div>
  );
}
